import { useEffect, useState } from "react";
import { ConsultaData, RutaProductos } from "./funcionesEspeciales";

function ProductosRelacionados({ articulo, agregarItemCarro }) {
    const [productosRelacionados, setProductosRelacionados] = useState([])
    useEffect(() => {
        getProductosRelacionados(articulo)
    }, [])
    const getProductosRelacionados = (id_articulo) => {
        ConsultaData('?/web/getArticulosRelacionados/&id=' + id_articulo).then(response => {
            setProductosRelacionados(response)
        })
    }
    const agregarAlCarrito = (producto) => {
        let producto_guardar = {
            id: producto.id,
            nombre: producto.nombre,
            imagen: producto.imagen,
            //precio_venta: calcularPrecioFinal(producto.valor_venta_base, producto.tipo_igv, producto.moneda),
            precio_venta: producto.precio_venta,
            descuento: 0,
            cantidad: 1,
        }
        agregarItemCarro(producto_guardar)
    }
    return (<>
        <div className="row">
            {productosRelacionados.map((producto, index) => (
                <div className="col-md-3" key={index}>
                    <div className="card">
                        <img src={RutaProductos + producto.imagen} className="card-img-top" alt="..." />
                        <div className="card-body">
                            <h5 className="card-title">{producto.art_nombre}</h5>
                            <p className="card-text">{producto.art_descripcion}</p>
                            <a href="#" onClick={(e) => agregarAlCarrito(producto)} className="btn btn-primary btn-sm">Agregar al Carrito</a>
                        </div>
                    </div>
                </div>
            ))
            }
        </div>
    </>)
}
export default ProductosRelacionados;